var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16 28.857c7.732 0 14-5.932 14-13.25s-6.268-13.25-14-13.25S2 8.29 2 15.607s6.268 13.25 14 13.25z",
    fill: "url(#A)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.424 18.178c-3.69 0-6.842.55-6.842 2.753s3.132 2.773 6.842 2.773c3.69 0 6.842-.55 6.842-2.753s-3.131-2.773-6.842-2.773z",
    fill: "url(#B)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.426 16.08c2.514 0 4.528-1.907 4.528-4.285S18.94 7.51 16.426 7.51s-4.528 1.907-4.528 4.285 2.015 4.285 4.528 4.285z",
    fill: "url(#C)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 2,
    y1: 2.357,
    x2: 2,
    y2: 28.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bde9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7d9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 9.582,
    y1: 18.178,
    x2: 9.582,
    y2: 23.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004cc4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 11.898,
    y1: 7.51,
    x2: 11.898,
    y2: 16.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bde9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7d9ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.63f482e7101f288f69b46becea06a844.svg";
export { ForwardRef as ReactComponent };